import { Customizations } from 'models'

const stockPageTableLabels: Customizations = {
  no: {
    label: 'Réf',
    isDisplayed: true,
  },
  referenceVendeur: {
    label: 'Réf vendeur',
    isDisplayed: true,
  },
  licensePlate: {
    label: 'Immat',
    isDisplayed: true,
  },
  type: {
    label: 'Genre',
    isDisplayed: true,
  },
  make: {
    label: 'Marque',
    isDisplayed: true,
  },

  normalVersion: {
    label: 'Type commercial',
    isDisplayed: true,
  },

  dateCreationDossier: {
    label: 'Date création',
    isDisplayed: true,
  },

  registrationCertificateReceivedDate: {
    label: 'Date réception CG',
    isDisplayed: true,
  },

  receiptDate: {
    label: 'Date de livraison',
    isDisplayed: true,
  },

  pickupLocationName: {
    label: 'Lieu enlèvement',
    isDisplayed: true,
  },
  locationLocationName: {
    label: 'Parc Stockage',
    isDisplayed: true,
  },

  auctionStartDateTime: {
    label: 'Date vente',
    isDisplayed: true,
  },

  generalStatus: {
    label: 'Statut général',
    isDisplayed: true,
  },

  logisticStatus: {
    label: 'Statut logistique',
    isDisplayed: true,
  },

  blockingReason: {
    label: 'Raison de blocage',
    isDisplayed: true,
  },
}

export { stockPageTableLabels }
